import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "rounded-xl border border-emerald-200 bg-emerald-50 p-4"
};
const _hoisted_2 = {
  class: "text-sm font-semibold text-emerald-800"
};
const _hoisted_3 = {
  class: "mt-3 max-h-96 overflow-y-auto rounded-lg bg-white p-3"
};
const _hoisted_4 = {
  key: 1,
  class: "text-sm font-semibold text-emerald-800"
};
import { computed } from 'vue';
import PlanSections from '../PlanSections.vue';
export default {
  __name: 'PlanDoneCard',
  props: {
    snapshot: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  emits: ['resume'],
  setup(__props) {
    const props = __props;
    const plan = computed(() => props.snapshot && props.snapshot.plan_json || {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [plan.value.plan_no ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("p", _hoisted_2, "方案已定稿：" + _toDisplayString(plan.value.plan_no), 1), _cache[0] || (_cache[0] = _createElementVNode("p", {
        class: "mt-1 text-xs text-emerald-600"
      }, "已回写 CRM（待顾问最终定稿导出），方案内容如下", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(PlanSections, {
        plan: plan.value
      }, null, 8, ["plan"])])], 64)) : (_openBlock(), _createElementBlock("p", _hoisted_4, "咨询已完成"))]);
    };
  }
};